/**
 * Store state selectors for the authentication module.
 */

import { RootStoreState } from 'modules/root'

export const currentUser = (state: RootStoreState) => state.auth.user
